import React,{
    useEffect,
    useState
} from "react";

import axios from "axios";

import "./AchievementProgress.css";

const AchievementProgress=()=>{

    const email=
    localStorage.getItem(
        "user_email"
    );

    const[summary,setSummary]=
    useState({

        completion:0,

        unlockedCount:0,

        claimedCount:0,

        totalAchievements:0

    });

    const[loading,setLoading]=
    useState(true);

    useEffect(()=>{

        if(email){

            loadProgress();

        }

    },[email]);

    const loadProgress=async()=>{

        try{

            const res=
            await axios.get(

                `/api/profile/${email}`

            );

            if(

                res.data?.summary

            ){

                setSummary({

                    completion:

                        res.data.summary.completion || 0,

                    unlockedCount:

                        res.data.summary.unlockedCount || 0,

                    claimedCount:

                        res.data.summary.claimedCount || 0,

                    totalAchievements:

                        res.data.summary.totalAchievements || 0

                });

            }

        }

        catch(err){

            console.error(err);

        }

        finally{

            setLoading(false);

        }

    };

    if(loading){

        return(

            <div className="achievement-progress-card">

                Loading...

            </div>

        );

    }

    return(

        <div className="achievement-progress-card">

            <div className="achievement-progress-header">

                <div>

                    <h2>

                        Achievement Progress

                    </h2>

                    <p>

                        Complete assessments and unlock more achievements.

                    </p>

                </div>

                <h3>

                    {summary.completion}%

                </h3>

            </div>

            <div className="achievement-progress-bar">

                <div

                    className="achievement-progress-fill"

                    style={{

                        width:`${summary.completion}%`

                    }}

                />

            </div>

            <div className="achievement-progress-footer">

                <span>

                    {summary.unlockedCount}

                    {" / "}

                    {summary.totalAchievements}

                    {" Achievements Unlocked"}

                </span>

                <span>

                    {summary.claimedCount}

                    {" Claimed"}

                </span>

            </div>

        </div>

    );

};

export default AchievementProgress;